.bonus_section {
  border-radius: 5px;
  background: #F8EEBF;
  padding: 12px 0;
  position: relative;
  overflow: visible;
  margin: 10px 0;

  label {
    display: flex;
    gap: 5px;
    align-content: center;
    align-items: center;
    cursor: pointer;

    .bonus {
      background-color: #000;
      color: #fff;
      padding: 8px 21px 8px 13px;
      font-family: var(--font-family, 'sofia-pro, sans-serif');
      font-size: 12px;
      font-style: normal;
      font-weight: 900;
      line-height: normal;
      position: relative;
      @media (max-width: 767px) {
        padding: 8px 18px 8px 4px;
      }
    }

    .bonus::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 0;
      height: 0;
      border-top: 17px solid transparent;
      border-bottom: 17px solid transparent;
      border-right: 17px solid #F8EEBF;
    }


    input {
      display: inline-block;
      width: 28px;
      height: 28px;
      border-radius: 3px;
      border: 2px solid #999;
      background: var(--White, #FFF);
      position: relative;
      cursor: pointer;
    }

    input[type=checkbox]::before, input[type=radio]::before {
      content: "✓";
      opacity: 0;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 28px;
      height: 28px;
      position: absolute;
      top: -2px;
      left: -2px;
      border-radius: 10%;
      transform: scale(1);
      font-size: 20px;
      font-weight: bold;
      box-shadow: none;
      background-color: transparent;
    }

    input[type=checkbox]:hover::before,
    input[type=radio]:hover::before {
      opacity: 0.5;
      color: #ccc;
      background-color: transparent;
    }

    input[type=checkbox]:checked::before, input[type=radio]:checked::before {
      transform: scale(1);
      opacity: 1;
      box-shadow: inset 28px 28px #00B902;
      color: #fff !important;
    }

    .title {
      color: #000;
      font-family: var(--font-family, 'sofia-pro, sans-serif');

      font-size: 16px;
      letter-spacing: -0.32px;
      font-style: normal;
      font-weight: 400;
      margin-left: 10px;
      line-height: 1em;

      @media (max-width: 767px) {
        font-size: 10px;
        font-weight: 400;
        letter-spacing: -0.2px;

      }

      strong {
        text-transform: uppercase;
        color: var(--Black, #000);
        font-family: var(--font-family, 'sofia-pro, sans-serif');
        display: block;
        font-weight: 900;
      }
    }

    .bonus_img {
      position: absolute;
      top: -10px;
      right: 15px;
    }

    @media (max-width: 767px) {
      .bonus_img {
        right: -18px;
      }
    }

    .bonus_img:after {
      content: "FREE";
      color: #fff;
      font-family: var(--font-family, 'sofia-pro, sans-serif');
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      position: absolute;
      top: 50%;
      right: -12px;
      width: 48px;
      height: 48px;
      margin-top: -24px;
      display: flex;
      align-content: center;
      justify-content: center;
      align-items: center;
      @media (max-width: 767px) {
        right: 4px;
      }
    }

    .bonus_img span:after {
      content: "$39.99";
      color: #fff;
      font-family: var(--font-family, 'sofia-pro, sans-serif');
      font-size: 9px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      position: absolute;
      top: 50%;
      text-decoration: line-through;
      right: -12px;
      width: 48px;
      height: 10px;
      margin-top: -14px;
      display: flex;
      align-content: center;
      justify-content: center;
      align-items: center;
      @media (max-width: 767px) {
        right: 4px;
      }
    }

    .bonus_img:before {
      animation: rotate 5s linear infinite;
      content: "";
      background: url("https://www.seatcoversolutions.com/cdn/shop/t/7/assets/circle-red.svg") no-repeat 0 0;
      position: absolute;
      top: 50%;
      right: -12px;
      width: 48px;
      height: 48px;
      margin-top: -24px;
      @media (max-width: 767px) {
        right: 4px;
      }
    }


  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg)
  }

  to {
    transform: rotate(1turn)
  }
}

.title {
  color: var(--Headings, #282828);
  text-align: center;
  font-family: var(--font-family, 'sofia-pro, sans-serif');
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 125% */
  margin-top: 20px;
  background-color: #FE0;
  color: #282828;
  padding-block: 2px;
}

.bonus3_section {
  margin-top: 30px;

  h3 {
    font-family: var(--font-family, 'sofia-pro, sans-serif');
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    text-align: center;

    strong {
      color: #ED1B34;
    }
  }
}

.bonus_items {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin: 20px 0 0 0;
  padding: 0;
  gap: 12px;

  li {
    list-style: none;
    display: flex;
    align-items: center;
    color: var(--Black, #000);
    text-align: center;
    font-family: var(--font-family, 'sofia-pro, sans-serif');
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    flex-direction: column;
    position: relative;
    opacity: 0.6;
    justify-content: flex-start;

    img {
      width: 100%;
    }

    .price {
      position: absolute;
      z-index: 2;
      top: -12px;
      padding: 2px 10px;
      background-color: #F8EEBF;
      border-radius: 5px;
      text-align: center;
      font-family: var(--font-family, 'sofia-pro, sans-serif');
      color: #000;
      font-size: 14px;
      font-style: normal;
      font-weight: 800;
      line-height: normal;


      s {
        color: #FB6764;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-decoration-line: strikethrough;
      }
    }

    &.active {
      display: flex;
      opacity: 1;

      .price {

      }

      .disabled {
        display: none;
        width: 100%;
      }

      .enabled {
        display: flex;
        width: 100%;
        min-height: 136px;
      }
    }

    p {
      margin-top: 10px;
      margin-bottom: 10px;
    }

  }

  .disabled {
    width: 100%;
    min-height: 136px;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    flex-direction: column;
    font-weight: 400;
    line-height: 115%; /* 18.4px */
    border-radius: 4px;
    border: 1px dashed #00B902;
    background: #F5F5F5;
    min-height: 136px;
    flex-grow: 1;
  }

  .enabled {
    display: none;
    color: #737373;
    text-align: center;
    font-family: var(--font-family, 'sofia-pro, sans-serif');
    font-size: 16px;
    font-style: normal;
    border-radius: 4px;
    border: 1px dashed #00B902;
    background: #F5F5F5;
    min-height: 136px;
    align-items: center;
    justify-content: center;
    align-content: center;
    flex-direction: column;
  }


}

.bonus3_title_section {
  padding: 0;
  position: relative;
  overflow: visible;
  margin: 10px 0;
  border: 0;
  display:block !important;

  .title {

    border-radius: 5px;
    border: 0;
    background-color: transparent;
    padding: 0;

    font-family: var(--font-family, 'sofia-pro, sans-serif');
    font-size: 12px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    display: grid;
    grid-template-columns: 1fr 1fr;

    strong {
      padding: 8px 20px 8px 6px;
      background: #000;
      color: #FFF;
      display: block;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      position: relative;

      &:after {
        content: "";
        width: 0;
        height: 0;
        border-top: 16.75px solid transparent;
        border-bottom: 16.75px solid transparent;

        border-right: 16.75px solid #F8EEBF;
        position: absolute;
        right: 0;
        top: 0;
      }

      @media (max-width: 767px) {
        font-size: 10px;
        letter-spacing: -0.6px;
      }
    }

    span {
      display: block;
      background: #F8EEBF;
      color: #000;
      padding: 8px 30px 8px 6px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      @media (max-width: 767px) {
        font-size: 10px;
        letter-spacing: -0.4px;
      }
    }
  }
}

.free_bonus_2_prods {
  .bonus_items {
    grid-template-columns: 2fr 1fr;
    justify-content: center;
    align-items: flex-start;
    align-content: flex-start;

    li {
      @media (max-width: 767px) {
        font-size: 12px;
        .enabled {
          min-height: auto;
        }
        img {
          max-height: none;
        }
      }
    }

    li:nth-child(1) {
      .enabled {
        max-height: 136px;
        border: 0 !important;
        border-radius: 4px;
        overflow: hidden;
      }

      img {

        aspect-ratio: auto;
        width: 100%;
        object-fit: cover;
        @media (max-width: 767px) {
          max-height: 103px;
        }
      }
    }

  }
}

.style01.bonus3_title_section {
  .title {
    span {
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      padding: 2px 5px 2px 5px;
      background-color: #FFF5E3;
    }
    strong:after {
      border-right-color: #FFF5E3;
    }
  }
  .bonus3_title_bottom {
    text-align: center;
    padding: 7px 0;
    background-color: #E9F7FE;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    font-family: var(--font-family, 'sofia-pro, sans-serif');
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    color:#000;
    a {
      text-decoration: underline;
    }
  }
}
